import { MapPin } from "lucide-react";
import { COUNTRY_FLAG_ICONS } from "variables/constants";

const EmployeeProfile = (props) => {
    const {avatar, 
        record, 
        size = "sm", 
        withEmpId=true, 
        withEmpJobTitle=false,
        withEmpLocation=false,
        empNameClass='',
        empIdClass='',
        empJobTitleClass='',
        nameInitialBg='bg-slate-100 dark:bg-slate-700',
        verticalAlignment="items-center"
    } = props;
    return (
        <div className={`flex gap-3 ${verticalAlignment}`}>
            {avatar ? 
            <img 
                src={avatar} 
                alt="Profile"
                className={`avatar rounded-full border-2 border-gray-300 ${size}`}
            />
            :
            <span className={`relative flex w-10 h-10 sm:w-8 sm:h-8 shrink-0 overflow-hidden rounded-full ${nameInitialBg}`}>
                <span className="flex size-full items-center justify-center font-semibold text-[12px] sm:text-[14px]">
                    {record?.employee_initials}
                </span>
            </span>
            } 
            <div>
                <div className={empNameClass}>{record?.employee_name}</div>
                {withEmpId && <div className={empIdClass}>{record?.emp_code}</div>}
                {withEmpJobTitle && <div className={empJobTitleClass}>{record?.emp_title}</div>}
                {withEmpLocation && 
                    <div className="flex items-center gap-1 mt-1">
                        <MapPin className="w-3 h-3 muted-text " />
                        {COUNTRY_FLAG_ICONS?.[record?.country_code] ?? null}
                        <div className={`w-2 h-2 rounded-full status-dot ${record?.country?.toLowerCase().replace(/\s+/g, "-")}`} />
                        <span className="text-[11px] muted-text ">
                            {record.country}
                        </span>
                    </div>
                }
            </div>
        </div>
    );
}

export default EmployeeProfile;
